import { IconLink, IconPencil, IconTrash } from '@tabler/icons-react';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { uploadImage } from '../../../../api/api.global';
import { getApi, postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import IconButton from '../../../../components/Buttons/IconButton';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';
import ToggleBtn from '../../../../components/Toggle/ToggleBtn';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';
import { disable, enable } from '../../../../redux/features/blockEdit/blockEditSlice';
import EditLinkOfBlock from '../EditLinkOfBlock';
import { ensureHttpPrefix } from '../../../../utils/url.utils';

const LinkBlockDragAndEdit = React.memo(({ data, callback, dragButton }) => {

    const [file, setFile] = useState(null);
    const imageUploadInputRef = useRef(null);
    const { pageId } = useParams();
    const dispatch = useDispatch();
    const isEditable = useSelector((state) => state.isBlockEdit?.value);

    let editableName = 'link-block-' + data?._id;

    const handleOnEditClick = () => {
        dispatch(enable(editableName))
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 1024 * 1024 * 5;
        if (file && file.size > maxSizeInBytes) {
            toast.error('File size exceeds the limit of 5MB.');
            setFile(null);
            e.target.value = null;
        } else {
            setFile(file);
        }
    }

    async function updateStatus(status) {
        let url = `${urlApi.updateBlockStatus}${pageId}/${data?._id}/${status}`;
        loadingShow();
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            if (callback) {
                callback();
            }
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }

    async function update(imageData) {
        if (document.getElementById('destinationUrl-' + imageData?._id).value?.trim() == '') {

            toast.error('Destination URL is required');
            return;
        }
        if (document.getElementById('title-' + imageData?._id).value?.trim() == '') {
            toast.error('Title is required');
            return;
        }
        loadingShow();
        let url = `${urlApi.updateBlockDetails}${pageId}/${data?._id}/${imageData?._id}`;
        let postData = {
            title: document.getElementById('title-' + imageData?._id).value?.trim(),
            description: document.getElementById('description-' + imageData?._id).value?.trim(),
            destinationUrl: ensureHttpPrefix(document.getElementById('destinationUrl-' + imageData?._id).value?.trim()),
            image: file ? await uploadImage(file, 'advy-pages') : imageData?.image
        }

        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            if (callback) {
                callback();
            }
            dispatch(disable(''))
            toast.success(resp.message);
        } else {
            toast.error(resp.message);
        }
    }


    return (
        <div className='w-full'>
            <div className='flex gap-3 items-center w-full mb-2'>
                {isEditable != editableName && dragButton}
                <div className="flex gap-1 items-center">
                    <IconLink size={16} />
                    <p className="mb-0 font-medium text-xs">Attriva Link</p>
                </div>
                {isEditable != editableName && <IconButton cssClass={'ms-auto'} icon={<IconPencil size={18} />} text={"Edit"} onClickFunction={() => handleOnEditClick(true)} />}
                {isEditable != editableName && <ConfirmationModal buttonComponent={<IconButton icon={<IconTrash size={18} />} />} confirmationText={"Are you sure want ro remove this block?"} onConfirm={() => updateStatus(3)} />}
            </div>

            <div className={`${isEditable == editableName ? 'ps-0' : 'ps-4'}`}>
                {isEditable == editableName ?
                    <div className='w-full'>
                        {
                            data?.images?.map((item, i) => {
                                return (
                                    <div key={i}>
                                        <div className="flex gap-3">
                                            <div className='w-40'>
                                                <input type="file" accept="image/*" name="" id="" className="hidden" onChange={handleImageChange} ref={imageUploadInputRef} />
                                                <button onClick={() => imageUploadInputRef.current.click()}>
                                                    <img src={file ? URL.createObjectURL(file) : item?.image ? item?.image : (process.env.PUBLIC_URL + "/images/image-upload.png")} id={'image-preview-' + data?._id} className='cursor-pointer  rounded-lg object-cover' alt="" />
                                                </button>
                                                <p className="text-xs text-gray-400">*Maximum size: 5MB, <br />preferred ratio is 1:1 </p>
                                            </div>
                                            <div className='w-full'>
                                                <p className="text-md font-semibold mb-1.5">Title & Description</p>
                                                <input type="text" className="form-control mb-2 w-full" placeholder="Enter Title" id={'title-' + item?._id} defaultValue={item?.title} maxLength={255} />
                                                <input type="text" className="form-control w-full" placeholder="Enter Description (Optional) (Max 140 Words)" id={'description-' + item?._id} defaultValue={item?.description} maxLength={140} />
                                            </div>
                                        </div>

                                        <EditLinkOfBlock blockData={item} />

                                        <div className="flex justify-end items-center mt-3 gap-3">
                                            <button className="font-semibold text-sm border-2 border-primary px-3 py-1.5 rounded-full" onClick={() => dispatch(disable(''))}>Cancel</button>
                                            <button className="font-semibold text-sm text-white bg-primary px-3 py-2 rounded-full" onClick={() => update(item)}>Update</button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    :
                    <div className='w-full'>
                        {
                            data?.images?.map((item, i) => {
                                return (
                                    <div className="flex gap-3 mb-2" key={i}>
                                        <img src={item?.image ? (item?.image) : process.env.PUBLIC_URL + "/images/image-upload.png"} alt="" className='h-20' />
                                        <div>
                                            <p className='mb-1 font-semibold'>{item?.title}</p>
                                            <p className="mb-0 text-xs text-[#686C8F]">{item?.description}</p>
                                            <a href={item?.link} className='text-xs text-primary hover:text-primary-dark'>{item?.link}</a>
                                        </div>
                                    </div>
                                )
                            })
                        }

                        <div className="flex justify-end">
                            <ToggleBtn state={data?.status == 1} onClickFunction={() => {
                                if (data?.status == 1) {
                                    updateStatus(2)
                                } if (data?.status == 2) {
                                    updateStatus(1)
                                }
                            }} />
                        </div>
                    </div>}
            </div>
        </div>
    )
})

export default LinkBlockDragAndEdit